module.exports = __webpack_public_path__ + "static/media/housing-insecurity.7ec9d050.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/housing-insecurity.jpg
// module id = 634
// module chunks = 11